import { HelpIcon, HelpIconContainer } from '../../../../../widgets/helpIconContainer';
import React from 'react';
import { T } from 'src/shared/helpers';
import ResizableMultipleSides from 'src/shared/svg/resizableMultipleSides';
import ResizableMultipleSynSides from 'src/shared/svg/resizableMultipleSynSides';
import ResizableOneSide from 'src/shared/svg/resizableOneSide';
import ResizableTwoSynSides from 'src/shared/svg/resizableTwoSynSides';
import ResizableTwoUnsynSides from 'src/shared/svg/resizableTwoUnsynSides';
import styled from 'styled-components';
import { ResizableSideType } from './resizablePrintAreaContext';

const Container = styled.div<{ $selected?: boolean }>`
    font-size: 13px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    border: 1px solid rgba(219, 226, 230, 1);
    border-radius: 8px;
    padding: 20px;

    cursor: pointer;
    border: ${(props) => (props.$selected ? '1px solid rgba(143, 164, 174, 1)' : '1px solid rgba(219, 226, 230, 1)')};
    box-shadow: ${(props) => (props.$selected ? '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)' : 'none')};

    &:hover {
        border: ${(props) => (!props.$selected ? '1px solid rgba(219, 226, 230, 1)' : '1px solid rgba(143, 164, 174, 1)')};
        box-shadow: ${(props) =>
            !props.$selected
                ? '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)'
                : '0px 4px 20px 0px rgba(0, 0, 0, 0.15), 0px 0px 3px 0px rgba(0, 0, 0, 0.1)'};
    }

    @media (max-width: 1475px) {
        height: 132px;
        font-size: 12px;
        padding: 20px 15px;
    }
`;

const HelpIconContainerStyled = styled(HelpIconContainer)`
    color: ${(props) => props.theme.app.component.icon.help.color};
`;

const ResizableSideTypeItemImg = styled.div`
    object-fit: contain;
    display: flex;
    justify-content: center;

    > svg {
        @media (min-width: 1325px) and (max-width: 1475px) {
            height: 64px;
        }
        @media (max-width: 1324px) {
            height: 50px;
        }
        height: 80px;
        width: auto;
    }
`;

const ResizableSideTypeItemLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

const ResizableSideTypeMap = {
    single: {
        imageComponent: <ResizableOneSide />,
        text: T._('One Side', 'Admin')
    },
    'double-syn': {
        imageComponent: <ResizableTwoSynSides />,
        text: T._('Front and Back', 'Admin')
    },
    double: {
        imageComponent: <ResizableTwoUnsynSides />,
        text: T._('Two Unsynced Sides', 'Admin')
    },
    multiple: {
        imageComponent: <ResizableMultipleSides />,
        text: T._('Mutiple Sides', 'Admin')
    },
    multiplesyn: {
        imageComponent: <ResizableMultipleSynSides />,
        text: T._('Mutiple Sides with Same Size', 'Admin')
    }
};

interface IResizableSideTypeItemProps {
    type: ResizableSideType;
    selected?: boolean;
    tooltip?: React.ReactNode;
    onClick?: () => void;
}

const ResizableSideTypeItem = ({ type, selected, tooltip, onClick }: IResizableSideTypeItemProps) => {
    return (
        <Container $selected={selected} onClick={onClick}>
            <ResizableSideTypeItemImg>{ResizableSideTypeMap[type].imageComponent}</ResizableSideTypeItemImg>
            <ResizableSideTypeItemLabel>
                {ResizableSideTypeMap[type].text}
                {tooltip && (
                    <HelpIconContainerStyled tooltip={tooltip}>
                        <HelpIcon />
                    </HelpIconContainerStyled>
                )}
            </ResizableSideTypeItemLabel>
        </Container>
    );
};

export default ResizableSideTypeItem;
